import "../../styles/Cards.css";
import TopNavbar2side from "../../components/TopNavbar2side";
import { useFetch } from "../../custom/api";
import { useEffect, useState } from "react";
import Card from "../../components/Card";
import { useParams } from "react-router-dom";
import GoToTop from "../../components/GoToTop";
import LoadingPage from "../../components/LoadingPage";
import InfiniteScroll from "react-infinite-scroll-component";

const Tag = () => {
  const { myFetch } = useFetch();
  const [tags, setTags] = useState(null);
  const params = useParams();
  const tagId = parseInt(params.id);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPage] = useState(0);

  function refresh() {
    window.location.reload();
  }

  useEffect(() => {
    const fetchData = async () => {
      const resp = await myFetch(`recipes/tag/${tagId}/${page}`, {
        method: "GET",
      });
      const r = await resp.json();

      if (tags === null) {
        setTags(r.content);
      } else {
        setTags([...tags, ...r.content]);
      }

      setTotalPage(r.total_pages);
    };
    fetchData();
  }, [page]);

  return (
    <>
      {tags === null ? (
        <LoadingPage />
      ) : (
        <>
          <TopNavbar2side
            title={tags[0]?.tag_description}
            sideTitle="همه غذاها"
            buttonHref={["/cards"]}
            buttonIcon={["dNone"]}
            classN={["rectangle"]}
          />

          <InfiniteScroll
            dataLength={tags.length} //This is important field to render the next data
            next={() => setPage(page + 1)}
            hasMore={page < totalPages}
            loader={<span className="loader"></span>}
            // endMessage={
            //   <p style={{ textAlign: "center" }}>
            //     <b>Yay! You have seen  it all</b>
            //   </p>
            // }
            // below props only if you need pull down functionality
            refreshFunction={refresh}
            pullDownToRefresh
            pullDownToRefreshThreshold={50}
            pullDownToRefreshContent={
              <h3 style={{ textAlign: "center" }}>
                &#8595; Pull down to refresh
              </h3>
            }
            releaseToRefreshContent={
              <h3 style={{ textAlign: "center" }}>
                &#8593; Release to refresh
              </h3>
            }
          >
            <div className="card-grid">
              {tags.map((card) => {
                return <Card card={card} key={Math.random()} />;
              })}
            </div>
          </InfiniteScroll>
        </>
      )}

      <GoToTop />
    </>
  );
};

export default Tag;
